import * as React from 'react'

import { Box, type MediumIcon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import ContractData from './ContractData'
import Header from './Header'

interface Props {
  icon: MediumIcon
  title: string
}

const Section = ({ icon, title, children }: React.PropsWithChildren<Props>) => {
  return (
    <Box gap="s16" flexDirection="column">
      <Header icon={icon} title={title} />
      <ContractData>{children}</ContractData>
    </Box>
  )
}

export default observer(Section)
